import React from "react"
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select } from "antd"
import { DownloadOutlined } from "@ant-design/icons"
import moment from "moment"
import styled from "styled-components"

const getDefaultDateFrom = () => moment().subtract(1, "day")

export function ReceiptFilters({ handleSearch, onExport, isExporting, paymentAccounts = [], points = [] }) {
  const [form] = Form.useForm()

  function buildFilters(values) {
    const filters = []

    if (values.dateFrom) {
      filters.push({
        t: "mOrE",
        f: "delivery_date",
        v: values.dateFrom.format("YYYY-MM-DD HH:mm:ss"),
      })
    }

    if (values.dateTo) {
      filters.push({
        t: "lOrE",
        f: "delivery_date",
        v: values.dateTo.format("YYYY-MM-DD HH:mm:ss"),
      })
    }

    if (values.innerId) {
      filters.push({
        t: "iL",
        f: "inner_id",
        v: values.innerId.trim(),
      })
    }

    if (values.paymentAccountId) {
      filters.push({
        t: "equal",
        f: "point.payment_account_id",
        v: String(values.paymentAccountId),
      })
    }

    if (values.pointId) {
      filters.push({
        t: "equal",
        f: "point_id",
        v: String(values.pointId),
      })
    }

    return filters
  }

  function onFinish(values) {
    handleSearch(
      buildFilters(values),
      Boolean(values.withDiscrepancies),
      Boolean(values.requiresAttention),
    )
  }

  function onReset() {
    form.resetFields()
    handleSearch(buildFilters(form.getFieldsValue()), false, false)
  }

  return (
    <StyledForm
      form={form}
      layout="inline"
      onFinish={onFinish}
      initialValues={{
        withDiscrepancies: false,
        requiresAttention: false,
        dateFrom: getDefaultDateFrom(),
      }}
    >
      <Form.Item name="dateFrom" label="Дата от">
        <DatePicker
          showTime={{ format: "HH:mm" }}
          format="DD.MM.YYYY HH:mm"
          placeholder="Дата от"
        />
      </Form.Item>
      <Form.Item name="dateTo" label="Дата до">
        <DatePicker
          showTime={{ format: "HH:mm" }}
          format="DD.MM.YYYY HH:mm"
          placeholder="Дата до"
        />
      </Form.Item>
      <Form.Item name="innerId" label="Номер заказа">
        <Input placeholder="Номер заказа" allowClear />
      </Form.Item>
      <Form.Item name="paymentAccountId" label="Юр. лицо">
        <Select
          allowClear
          showSearch
          optionFilterProp="label"
          placeholder="Все юр. лица"
          style={{ minWidth: 200 }}
          options={paymentAccounts.map((acc) => ({
            label: acc.name,
            value: acc.id,
          }))}
        />
      </Form.Item>
      <Form.Item name="pointId" label="Точка">
        <Select
          allowClear
          showSearch
          optionFilterProp="label"
          placeholder="Все точки"
          style={{ minWidth: 200 }}
          options={points.map((point) => ({
            label: point.name,
            value: point.id,
          }))}
        />
      </Form.Item>
      <Form.Item name="withDiscrepancies" valuePropName="checked">
        <Checkbox>Только с расхождениями</Checkbox>
      </Form.Item>
      <Form.Item name="requiresAttention" valuePropName="checked">
        <Checkbox>Требуют внимания</Checkbox>
      </Form.Item>
      <Form.Item>
        <Row gutter={8}>
          <Col>
            <Button type="primary" htmlType="submit">
              Найти
            </Button>
          </Col>
          <Col>
            <Button onClick={onReset}>Сбросить</Button>
          </Col>
          <Col>
            <Button
              icon={<DownloadOutlined />}
              onClick={onExport}
              loading={isExporting}
            >
              Выгрузить CSV
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </StyledForm>
  )
}

const StyledForm = styled(Form)`
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #fafafa;
  border-radius: 6px;
`
